"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignedPatientsProvider = AssignedPatientsProvider;
const domain_1 = require("@home-health-notify/domain");
const react_1 = __importStar(require("react"));
const AssignedPatientsContext_1 = require("./AssignedPatientsContext");
const OrganizationContext_1 = require("./OrganizationContext");
const ChatContext_1 = require("./ChatContext");
const useEffectCancellable_1 = require("../hooks/useEffectCancellable");
function AssignedPatientsProvider({ children, }) {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const { chat } = (0, react_1.useContext)(ChatContext_1.ChatContext);
    const chatId = chat === null || chat === void 0 ? void 0 : chat.getChatId();
    const groupType = chat === null || chat === void 0 ? void 0 : chat.chatInfo.groupType;
    const canAccessAssignedPatients = selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.hasAccess(domain_1.FEATURES.VIEW_ASSIGNED_PATIENTS);
    const [assignedPatients, setAssignedPatients] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const getAssignedPatients = (context) => __awaiter(this, void 0, void 0, function* () {
        if (!canAccessAssignedPatients) {
            return;
        }
        setIsLoading(true);
        yield (chat === null || chat === void 0 ? void 0 : chat.fetchAssignedPatients(context));
        if (!context.isAborted) {
            (chat === null || chat === void 0 ? void 0 : chat.assignedPatients) && setAssignedPatients(chat === null || chat === void 0 ? void 0 : chat.assignedPatients);
            setIsLoading(false);
        }
    });
    (0, useEffectCancellable_1.useEffectCancellable)(context => {
        const chatManager = groupType &&
            (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getChatManagerForGroupType(groupType));
        const shouldFetchAssignedPatients = chatId && chatManager && groupType === domain_1.GROUP_TYPE.PRIVATE;
        if (shouldFetchAssignedPatients) {
            getAssignedPatients(context);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chatId]);
    return (react_1.default.createElement(AssignedPatientsContext_1.AssignedPatientsContext.Provider, { value: { isLoading, assignedPatients } }, children));
}
